module.exports = __webpack_public_path__ + "img/result-detail-output-outleft03.96b52e92.svg";